export default __webpack_public_path__ + "resources/icons/n431-e50b.png";